module.exports = __webpack_public_path__ + "static/media/021admin_8 IMEI @2x.794b9076.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/screenshots/optus/021admin_8 IMEI @2x.png
// module id = 586
// module chunks = 0